<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>
    <template v-slot:header>
      {{ title }}
    </template>

    <VehicleSearch :formUrl="$route('builds.create')"
                   :filters="filters">
      <template v-slot:header>
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">Find Vehicle</h3>
      </template>
    </VehicleSearch>

    <DataTable class="mt-4" v-if="vehicles.length">
      <template v-slot:header>
        <th scope="col" class="">
          Name
        </th>
        <th scope="col">
          Make
        </th>
        <th scope="col">
          Model
        </th>
        <th scope="col">
          Years
        </th>
        <th scope="col">
          <span class="sr-only">Choose</span>
        </th>
      </template>

      <tr v-for="vehicle in vehicles" :key="vehicle.id">
        <td>{{ vehicle.name }}</td>
        <td>{{ vehicle.make }}</td>
        <td>{{ vehicle.model }}</td>
        <td>{{ getYears(vehicle) }}</td>
        <td>
          <Link :href="$route('builds.create', { ...selectedOptions, vehicle_id: vehicle.id })" class="text-indigo-600 hover:text-indigo-900">Choose</Link>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import SelectCommon from './select-common'
import VehicleSearch from '../vehicles/index-search.vue'

export default {
  extends: SelectCommon,

  components: {
    VehicleSearch,
  },

  props: {
    vehicles: Array,
    filters: Object,
  },

  methods: {
    getYears (vehicle) {
      return [vehicle.start_year, vehicle.end_year]
        .reduce(
          (carry, item) => carry.includes(item)
            ? carry
            : carry.concat(item),
          [],
        )
        .join('-')
    },

    getSelectedOptions() {
      const { vehicle_id, ...selectedOptions } = this.selectedOptions
      return selectedOptions
    }
  }
}
</script>
